import { 
	UploadItem,
	UploadOptions,
	UploadItemCallback ,
	UploadFile
} from 'phoenix/domain';
import { AuthService } from 'phoenix/services';
import { IUriPathService } from 'phoenix/services/uriPathService';
import { UploadExceptionFactory } from 'phoenix/factories/upload-exception-factory';

export class UploadItemFactory{
	public static $inject = [
		'pxAuthService',
		'pxUriPathService',
		'pxUploadExceptionFactory'
	];	

	constructor(
		private pxAuthService:AuthService,
		private pxUriPathService:IUriPathService,
		private pxUploadExceptionFactory:UploadExceptionFactory
	){
	}

	public create(file:UploadFile, callback:UploadItemCallback, options:UploadOptions){
		return new UploadItem(
			this.pxAuthService,
			this.pxUriPathService,
			this.pxUploadExceptionFactory,
			file,
			callback,
			options
		);
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/factories/upload-item-factory.ts